const deployed = true
const localUrl = 'http://localhost:8080/growth-dyclss'

// set up for reverse proxy in nginx, see default.conf
const deployedUrl = '/api'
let siteUrl = ''
if (deployed) {
  siteUrl = deployedUrl
} else
  siteUrl = localUrl
export default siteUrl